export default "__VITE_ASSET__550581df__"